module.exports = __webpack_public_path__ + "img/source-search_type-tag.3b0150a7.svg";